//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      // key: value
      timer:null,
      gainNames:[],
      start:false
    }
  },
  props: {
    list: {
      type: Array,
      default: ()=>{
        return []
      }
    },
  },
  watch: {
    list:{
      deep:true,
      handler(newVal, oldVal) {
       this.go(newVal)
      },
      
    }
  },
  beforeDestroy(){
      window.clearInterval(this.timer);     //  离开页面清除（移除）定时器

  },
  mounted () {
    this.go(this.list)
  },
  methods: {
    go(newVal){
      if(!newVal.length){
        return false
      }

       this.gainNames = newVal
         // // 滚动信息
        window.clearInterval(this.timer);  
        this.timer = setInterval(()=>{
            this.start = true
            setTimeout(()=>{
                    this.start = false
                    console.log("1234")
                    let item = this.gainNames.shift()
                    this.gainNames.push(item)
            },1000) 
        },3000);
    }
  },

}
